import styles from "./file-view.module.css";
import { Flex } from "antd";

import FilmIcon from "@/icons/FilmIcon";
import FileIcon from "@/icons/FileIcon";
import ZipIcon from "@/icons/ZipIcon";
import FileTextIcon from "@/icons/FileTextIcon";
import FilePdfIcon from "@/icons/FilePdfIcon";
import FileExcelIcon from "@/icons/FileExcelIcon";
import DownloadIcon from "@/icons/DownloadIcon";

const getIconByType = (type, extension, color) => {
  switch (type) {
    case "video":
      return <FilmIcon style={{ color, fontSize: "16px" }} />;

    case "application":
      switch (extension) {
        case "zip":
          return <ZipIcon style={{ color, fontSize: "16px" }} />;
        case "docx":
          return <FileTextIcon style={{ color, fontSize: "16px" }} />;
        case "pdf":
          return <FilePdfIcon style={{ color, fontSize: "16px" }} />;
        case "xlsx":
          return <FileExcelIcon style={{ color, fontSize: "16px" }} />;
        default:
          return <FileIcon style={{ color, fontSize: "16px" }} />;
      }

    default:
      return <FileIcon style={{ color, fontSize: "16px" }} />;
  }
};

const FileView = ({ file }) => {
  if (!file) {
    return null; // Возвращаем null, если параметры не переданы
  }

  switch (file.type) {
    case "image":
      return (
        <div className={styles.imageWrap}>
          <img
            src={file.path}
            style={{ maxWidth: "100%", maxHeight: "820px" }}
            alt="File preview"
          />
          <div className={styles.name}>{file.original_name}</div>
        </div>
      );
    default:
      return (
        <Flex align="center" gap={5}>
          {getIconByType(file.type, file.extension, "var(--color-primary)")}
          <div style={{ lineHeight: 1 }}>{file.original_name}</div>

          <a
            href={`/api/file/download?uuid=${file.uuid}`}
            download={file.original_name}
            style={{ fontSize: "16px" }}
          >
            <DownloadIcon
              style={{
                color: "var(--color-primary)",
                fontSize: "16px",
              }}
            />
          </a>
        </Flex>
      );
  }
};

export default FileView;
